// Конфигурация времени выполнения из public/config.js (в Docker пишется из env при старте).

export interface RuntimeConfig {
  oidcAuthority?: string;
  oidcClientId?: string;
  apiBase?: string;
}

declare global {
  interface Window {
    __LABCONNECT_CONFIG__?: RuntimeConfig;
  }
}

const raw: RuntimeConfig = (typeof window !== 'undefined' && window.__LABCONNECT_CONFIG__) || {};
const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';

export const config = {
  origin,
  oidcAuthority: raw.oidcAuthority || `${origin}/auth/realms/labconnect`,
  oidcClientId: raw.oidcClientId || 'labconnect-web',
  apiBase: (raw.apiBase || '/api/v1').replace(/\/$/, ''),
};
